import { Component } from '@angular/core';
import { AppService } from 'src/app/services/app.service';
import { RouterParams } from 'src/app/services/router-params.service';

@Component({
  selector: 'app-confirmation-page',
  templateUrl: './confirmation-page.component.html',
  styleUrls: ['./confirmation-page.component.scss']
})
export class ConfirmationPageComponent {
  public email: string;
  public type: string;
  public returnType: string;

  constructor(private app: AppService, private params: RouterParams) {
    Object.assign(this, this.params.data);
    if (this.type) {

    } else {
      this.app.router.navigateByUrl('');
    }
  }

}
